module.exports = __webpack_public_path__ + "static/overview-portrait-1@2x-b050d47ac79f185767448a3bec5aef2f.jpg";